import { stargateProxyUrl } from './selectHost';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function isStargateProxyPath({ apiHost }: { apiHost: string }): boolean {
	return apiHost === stargateProxyUrl();
}
